import { CancelButton, SubmitButton } from "../../../../../-components/Buttons"
import { ModalForm } from "../../../../../-components/typed-form"
import { UserId } from "../../../../../@client/Absents"
import { AbsenceUserWithEmailInfoSelect } from "../../../../../-components/AbsenceUserWithEmailInfoSelect"
import { userSelectRenderOptionWithEmailAddressWarning } from "../../../../../-components/userSelectRenderOptionWithEmailAddressWarning"
import { Group, Stack, Textarea, Checkbox } from "@mantine/core"
import { showErrorNotification } from "../../../../../utils/form-submission-notifications"
import { useTranslations } from "../../../../../utils/use-t"
import { useInvalidate } from "../../../../../typed-client/hooks/use-invalidate"

export function AddApprovalStepModal({
  opened,
  onClose,
  leaveRequestId,
}: {
  opened: boolean
  onClose: () => void
  leaveRequestId: number
}) {
  const ts = useTranslations()
  const invalidate = useInvalidate()
  return (
    <ModalForm<
      {
        users: UserId[]
        note: string | null
        canChangeFinalDecision: boolean
        rejectionIsFinal: boolean
      },
      "/api/Absence/Command"
    >
      url="/api/Absence/Command"
      title={ts.absences.t("AddApprovalStep")}
      opened={opened}
      closeOnClickOutside={false}
      onClose={() => {
        onClose()
      }}
      options={{
        onError: showErrorNotification,
        onSuccess: () => {
          invalidate("/api/Absence/GetApprovalRequestForReview")
          onClose()
        },
      }}
      initialValues={{
        users: [],
        note: null,
        canChangeFinalDecision: false,
        rejectionIsFinal: false,
      }}
      transform={(v) => ({
        streamId: leaveRequestId,
        command: {
          Case: "AddApprovalStep",
          Fields: {
            users: v.users || [],
            noteForApprovers: v.note || null,
            canChangeFinalDecision: v.canChangeFinalDecision,
            rejectionIsFinal: v.rejectionIsFinal,
          },
        },
      })}
    >
      {(f, _, m) => (
        <Stack>
          <AbsenceUserWithEmailInfoSelect
            label={ts.appServer.t("Users")}
            required
            autoFocus
            UserType="Users"
            renderOption={userSelectRenderOptionWithEmailAddressWarning}
            {...f.getInputProps(_.users._PATH_)}
          />
          <Textarea
            label={ts.absences.t("NoteForApprovers_Label")}
            placeholder={ts.absences.t("NoteForApprovers_Placeholder")}
            {...f.getInputProps(_.note._PATH_)}
          />
          <Checkbox
            label={ts.absences.t("RejectionIsFinal")}
            {...f.getInputProps(_.rejectionIsFinal._PATH_)}
          />
          <Checkbox
            label={ts.absences.t("CanChangeFinalDecision")}
            {...f.getInputProps(_.canChangeFinalDecision._PATH_)}
          />

          <Group justify="space-between" mt="xs">
            <CancelButton
              variant="default"
              onClick={() => onClose()}
              // setShowAddApprovalModalOpened(false)}
            />
            <SubmitButton loading={m.isPending}>
              {ts.appServer.t("Add")}
            </SubmitButton>
          </Group>
        </Stack>
      )}
    </ModalForm>
  )
}
